import styled from "styled-components";

export const Container = styled.section`
  margin-top: 8rem;
  display: grid;
  grid-template-columns: 1fr 420px;
  gap: 2.4rem;
  align-items: start;

  .about-card{
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
  }

  h2{
    font-size: 3.2rem;
    color: var(--text);
  }

  p{
    font-size: 1.6rem;
    color: var(--text);
    opacity: 0.95;
  }

  .meta-row{ display:flex; gap:1.2rem; flex-wrap:wrap; align-items:center; }

  /* skill badges */
  .skills-wrap{
    display:flex; gap:0.8rem; flex-wrap:wrap; margin-top:0.6rem;
  }
  .skill-badge{
    background: linear-gradient(180deg, rgba(255,255,255,0.02), rgba(255,255,255,0.01));
    border: 1px solid var(--glass-border);
    padding: 0.45rem 0.9rem;
    border-radius: 999px;
    font-size: 1.4rem;
    color: var(--text);
    box-shadow: 0 6px 18px rgba(2,6,23,0.5);
  }

  .about-image{
    display:flex; align-items:center; justify-content:center;
  }
  .image-frame{
    width:100%; max-width: 380px; border-radius: 18px;
    padding: 8px; background: linear-gradient(90deg,var(--accent-1),var(--accent-2));
    display: inline-block;
    box-shadow: 0 10px 30px rgba(2,6,23,0.55);
  }
  .image-frame img{
    display:block; width:100%; height:auto; border-radius: 12px; background: #0b1220;
    transition: transform 220ms ease, filter 220ms ease, box-shadow 220ms ease;
  }
  .image-frame:hover img{ transform: translateY(-6px) scale(1.01); filter: saturate(1.02); box-shadow: 0 18px 40px rgba(2,6,23,0.6); }

  /* ensure the image frame doesn't inherit section-card padding if used together */
  .image-frame.section-card{ padding: 8px; }

  .section-card{ /* reuse global glass card */ }

  .achievements ul, .honors ul{ padding-left: 1.2rem; }
  .achievements li{ margin-bottom: 0.45rem; }

  @media (max-width: 980px){
    grid-template-columns: 1fr;
    .image-frame{ margin: 0 auto; max-width: 320px; }
  }
`